export default __webpack_public_path__ + "assets/images/4dbaf31aa3aa7fbf66f1c52a303e5743.png";